export default "__VITE_ASSET__Boz9BxGX__"